import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLanguage } from "@/contexts/LanguageContext";
import { useUserRole } from "@/hooks/useUserRole";
import { AuthMarketingPanel } from "@/components/auth/AuthMarketingPanel";
import { AuthForm } from "@/components/auth/AuthForm";

export const Auth = () => {
  const { user } = useAuth();
  const { isRTL } = useLanguage();
  const { role, loading: roleLoading, hasRole } = useUserRole();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    if (roleLoading) return;

    if (!hasRole) {
      // New Google user without a role – send to role selection
      navigate("/select-role");
    } else {
      navigate("/");
    }
  }, [user, roleLoading, hasRole, navigate]);

  return (
    <main className="min-h-screen flex flex-col lg:flex-row" dir={isRTL ? "rtl" : "ltr"}>
      <AuthMarketingPanel isRTL={isRTL} />
      <AuthForm isRTL={isRTL} />
    </main>
  );
};
